export const SPLIT_CHAR_SPECIAL = ';||';
export const CONCAT_STR_AGG = '; ';
export const SPLIT_CHAR_MULTI = ';,';
